import {EntryShared, socket, uiManagerEvents, setUIManagerEvents} from '../shared/scripts/EntryShared.ts'
import {SocketWebActionController} from './scripts/SocketActionController.ts'
import {type UIWHeaderController} from './scripts/ui_html/header/UIWHeaderController.ts'
import {UIWGeneralServicesController} from './scripts/UIWGeneralServicesController.ts'
import {UINotificationSendHelper} from '../shared/scripts/notifications/UINotificationSendHelper.ts'
import {UIWNotificationController} from './scripts/notifications/UIWNotificationController.ts'
import {UIWManagerEvents} from './scripts/ui_html/UIWManagerEvents.ts'

export class EntrySingletonPageShared {
    static initializeSocketAndGeneralServices(headerController: UIWHeaderController | undefined) {
        if(uiManagerEvents == undefined) setUIManagerEvents(new UIWManagerEvents(undefined))
        const generalServicesController = new UIWGeneralServicesController(undefined, headerController)
        const socketActionController = new SocketWebActionController(undefined, undefined, generalServicesController)
        EntryShared.initializeSocket(socketActionController)
        EntryShared.initializeNotification(new UIWNotificationController())

        socket.connect()

        generalServicesController.init()

        UINotificationSendHelper.init()
    }
}
